export const translations = {
  nav: {
    home: "Home",
    about: "About",
    services: "Services",
    contact: "Contact",
    studentPlatform: "Student Portal",
    otherProducts: "Other Products"
  },
  hero: {
    title: "AI-Driven SaaS Product Partner",
    subtitle: "We pair reusable cloud-native foundations with domain LLM expertise to help scale-ups launch operable intelligent products in under 12 weeks.",
    cta: "Book a Strategy Call"
  },
  features: {
    title: "AI-Native SaaS Capability Matrix",
    items: [
      {
        title: "Zero-to-One Product Co-Creation",
        description: "Strategy, design, and engineering partner from day one.",
        longDescription: "We run 2-week design sprints and iterative prototype reviews to translate business goals into roles, workflows, and success metrics so AI features stay tied to real operating scenarios.",
        icon: "🧭"
      },
      {
        title: "AI Native Technical Base",
        description: "Multimodal models, workflow orchestration, and RBAC pre-integrated.",
        longDescription: "Prompt/Agent governance, observability, vector search, FinOps dashboards, and staged rollout pipelines plug into OpenAI, Claude, Azure AI Studio, and other leading providers.",
        icon: "🤖"
      },
      {
        title: "Managed Delivery Rhythm",
        description: "Demo-ready increments every sprint, production readiness in 12 weeks.",
        longDescription: "Scrum with bi-weekly milestones plus quality gates, regression suites, automated deploys, and performance baselines keep progress transparent and reversible.",
        icon: "⚙️"
      },
      {
        title: "Enterprise Security & Compliance",
        description: "Data isolation, audit trails, and compliance kits from day one.",
        longDescription: "We mirror SOC2, ISO27001, and China Xinchuang requirements across IAM, logging, and risk control, shipping ready-to-use security whitepapers and procurement documentation.",
        icon: "🛡️"
      }
    ]
  },
  members: {
    title: "Core Team",
    stories: [
      {
        name: "Mersen",
        role: "Platform Architecture Lead",
        quote: "Delivered 20+ multi-tenant SaaS platforms across North America and APAC, leading event-driven architecture and observability programs with bi-weekly release cadences."
      },
      {
        name: "Alvin",
        role: "AI Product Scientist",
        quote: "Owns industry model benchmarking and prompt asset libraries, mapping AI capabilities to measurable business KPIs with governance built in."
      }
    ]
  },
  services: {
    title: "Service Lines",
    mostPopular: "CORE",
    getStarted: "Schedule a Call",
    items: [
      {
        name: "Strategy & Blueprint Workshop",
        features: [
          "AI product positioning and business KPI definition",
          "Persona journeys and high-friction moments",
          "Deliverable modules and data dependency map",
          "Lo-fi flows plus prioritized roadmap"
        ]
      },
      {
        name: "AI SaaS Co-Build",
        features: [
          "6-12 week embedded cross-functional pod",
          "Cloud-native multi-tenant architecture & isolation",
          "Prompt / Agent management and monitoring console",
          "CI/CD + observability out of the box",
          "30-day post-launch performance and UX audit"
        ]
      },
      {
        name: "Platform Co-Operate",
        price: "Custom",
        period: "Annual",
        features: [
          "SRE-grade monitoring with SLA ≥ 99.9%",
          "Continuous model + prompt optimization",
          "Tier-2 support, incident response, and retros",
          "FinOps insights and optimization reports"
        ]
      }
    ]
  },
  faq: {
    title: "Frequently Asked Questions",
    items: [
      {
        question: "How do we start?",
        answer: "Kick off with a 30-minute discovery call. We ship a delivery plan and quote within 5 business days once goals and timelines are aligned."
      },
      {
        question: "Which industries do you focus on?",
        answer: "B2B SaaS, retail, education, regulated finance, and digital government cases that require multi-tenant controls and complex permissions."
      },
      {
        question: "How is delivery risk managed?",
        answer: "Bi-weekly demo days, automated tests, and performance baselines ensure traceable progress and allow early course-correction."
      },
      {
        question: "Is our data secure?",
        answer: "Yes. Data tiering, access auditing, and rotating secrets are built in, aligning with SOC2, ISO27001, and Xinchuang standards."
      },
      {
        question: "Can you integrate with our stack?",
        answer: "We expose APIs, webhooks, and iPaaS playbooks, and can connect Salesforce, Workday, DingTalk, WeCom, and more."
      }
    ]
  },
  contact: {
    title: "Contact Us",
    email: {
      label: "Email",
      value: "info@ctrlcv.com"
    },
    wechat: {
      label: "WeChat",
      qrAlt: "WeChat QR Code"
    },
    xiaohongshu: {
      label: "Xiaohongshu",
      qrAlt: "Xiaohongshu QR Code"
    }
  },
  footer: {
    copyright: "© 2024 CtrlCV Ltd. All rights reserved."
  }
};

